import { DeleteArrowBack } from '@styled-icons/fluentui-system-regular/DeleteArrowBack';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledIconButton } from '@/components/Buttons';

interface Props {
  anyPointsDrawn: boolean;
  deleteLastPoint: () => void;
}

function DeleteLastPoint({
  anyPointsDrawn,
  deleteLastPoint,
}: Props): React.ReactElement {
  const { t } = useTranslation();
  return (
    anyPointsDrawn && (
      <StyledIconButton
        onClick={() => deleteLastPoint()}
        $withText
        icon={<DeleteArrowBack size={24} />}
      >
        {t('Remove last point')}
      </StyledIconButton>
    )
  );
}

export default DeleteLastPoint;
